import { createSlice } from "@reduxjs/toolkit";

const initialJobState = {
  reports: null,
  totalPages: null,
  listLoading: false,
  totalResults: null,
  actionLoading: false,
};

export const reportManagementSlice = createSlice({
  name: "reportManagementSlice",
  initialState: initialJobState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    setReports: (state, action) => {

      const { report, totalPages, totalResults } = action.payload;
      state.listLoading = false;
      state.reports = report || [];
      state.totalPages = totalPages || null;
      state.totalResults = totalResults;

    },
    cleanUpReports: (state, action) => {
      state.reports = null;
      state.totalPages = null;
      state.listLoading = false;
      state.totalResults = null;
      state.actionLoading = false;
    },
  },
});
